import { URLSearchParamsInit } from 'react-router-dom';
import { Params } from 'ahooks/lib/useAntdTable/types';
import { RawAxiosRequestHeaders } from 'axios';
import dayjs from 'dayjs';

import { apiGet } from 'api';

import { addQueryParamsToURL, getDateForPayload, getTableQueryParams } from 'utils';

import { TransactionsDashboard } from 'codegen';

export interface IInitialValues {
  statuses: string[];
  collectorId?: string;
  submittedDates: dayjs.Dayjs[] | null;
  collectorNumber: string;
  riceTransactionId: string;
}

export const handleTransactionsTableChange = (
  headers: RawAxiosRequestHeaders,
  setSearchParams: (nextInit: URLSearchParamsInit) => void,
) => async (
  params: Params[0],
  {
    statuses,
    collectorId,
    submittedDates,
    collectorNumber,
    riceTransactionId,
  }: IInitialValues,
) => {
  const tableQueryParams = getTableQueryParams(params);

  const queryParams = {
    ...tableQueryParams,
    ...(statuses && { statuses }),
    ...(collectorId && { collectorId }),
    ...(collectorNumber && { collectorNumber }),
    ...(riceTransactionId && { riceTransactionId }),
    ...(submittedDates && {
      createdTo: getDateForPayload(dayjs(submittedDates[1]).endOf('day')),
      createdFrom: getDateForPayload(dayjs(submittedDates[0])),
    }),
  };

  setSearchParams(addQueryParamsToURL('', queryParams));

  const url = addQueryParamsToURL('/transactions', queryParams);

  const { data } = await apiGet<TransactionsDashboard>({ url, headers });

  return {
    list: data.transactions,
    total: data.total,
  };
};
